import React from "react";
import s from "./modal.module.css"
import cn from "classnames"


export default ({active, setActive, children}) => {
    return <div className={cn(s.modal, {[s.modalActive]: active})} onClick={() => setActive(false)}>
        <div className={cn(s.modalContent, {[s.active]: active})} onClick={e => e.stopPropagation()}>
            {children}
        </div>
    </div>
};
